export default __webpack_public_path__ + "static/media/icone-mala.5424bc6d.svg";